import { render, staticRenderFns } from "./JobAlertV2.html?vue&type=template&id=21405e47&scoped=true&%3Akey=componentKey&"
import script from "./JobAlertPageV2.vue?vue&type=script&lang=ts&"
export * from "./JobAlertPageV2.vue?vue&type=script&lang=ts&"
import style0 from "./JobAlertPageV2.vue?vue&type=style&index=0&id=21405e47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21405e47",
  null
  
)

export default component.exports